export const CREATE_SKILLS = `
    mutation CreateSkill($name:String , $photo:Upload , $groupId:String ){
        createSkill(name:$name , photo:$photo , groupId:$groupId){
            message
            skill {
                id_skill 
                name
                photo
            }
        }
    }
`;

export const UPDATE_SKILLS = `
    mutation updateSkill($id: ID, $name: String , $photo:Upload , $groupId:String ){
        updateSkill(id:$id, name:$name , photo:$photo , groupId:$groupId){
            message
            skill {
                id_skill 
                name
                photo
            }
        }
    }
`;

export const DELETE_SKILLS = `
    mutation deleteSkill($id:ID){
        deleteSkill(id:$id){
            message
            skill {
                id_skill 
                name
                photo
            }
        }
    }
`;